import * as THREE from 'https://threejsfundamentals.org/threejs/resources/threejs/r127/build/three.module.js';
import { OrbitControls } from 'https://threejsfundamentals.org/threejs/resources/threejs/r127/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'https://threejsfundamentals.org/threejs/resources/threejs/r127/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'https://threejsfundamentals.org/threejs/resources/threejs/r127/examples/jsm/loaders/RGBELoader.js';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

const canvas = document.getElementById('3d-model');
const renderer = new THREE.WebGLRenderer({canvas});
const fov = 20;
const camera = new THREE.PerspectiveCamera(fov, window.innerWidth / window.innerHeight, 1, 1000);
const controls = new OrbitControls(camera, canvas);
const scene = new THREE.Scene();
const fovMin = 18;
const fovMax = 25;
let explore_legend = null;
let autoRotateActive = false;
let fovTmp = 0;
let annotions = new Array();
let clickablePoints = new Array();
const annotionDetails = [
    {
        coordinates: [0.05, 0.55, 0.15],
        width: 480,
        height: 172,
        path: "https://cdn.shopify.com/s/files/1/0575/2317/5576/files/The_Campaign_1.png",
        id: "the-campain"
    },
    {
        coordinates: [0.45, 0.5, -0.1],
        width: 680,
        height: 172,
        path: "https://cdn.shopify.com/s/files/1/0575/2317/5576/files/discover-the-fragrance_1.png",
        id: "the-fragrance"
    },
    {
        coordinates: [0.42, 0.5, -0.3],
        width: 580,
        height: 172,
        path: "https://cdn.shopify.com/s/files/1/0575/2317/5576/files/behind-the-scenes_1.png",
        id: "behind-the-scene"
    },
    {
        coordinates: [-0.35, 0.55, -0.25],
        width: 580,
        height: 172,
        path: "https://cdn.shopify.com/s/files/1/0575/2317/5576/files/Explore_The_Bottle.png",
        id: "the-bottle"
    }
];

controls.enableZoom = false;
controls.enableRotate = false;

// Manage HDR images for Backround and Envirement
var pmremGenerator = new THREE.PMREMGenerator(renderer);
pmremGenerator.compileEquirectangularShader();

class bottleModal {
    constructor() {
        this.manageBGandEnvfiles();
        this.manageLights();
        this.loadGLBModal();
    }

    rendererPropUpdate(){
        const renderSettings = {
            "type": 1,
            "color": 16758881,
            "antialias": false,
            "toneMapping": THREE.ReinhardToneMapping,
            "outputEncoding": 3007,
            "gammaFactor": 0.6,
            "intensity": 10,
            "opacity": 1
        }
        for (const setting in renderSettings) {
            renderer[setting] = renderSettings[setting];
        }
    }

    manageAutoRotate(){
        controls.autoRotate = true;
        let rotationCount = 0;
        autoRotateActive = true;
        const autoRotate = setInterval(() => {
            rotationCount += 1;
            if(rotationCount == 2){
                controls.autoRotateSpeed *= -2;
            }
            else if(rotationCount == 4){
                controls.autoRotateSpeed = 2;
            }else if(rotationCount == 6){
                controls.autoRotate = false;
                controls.enableRotate = true;
                autoRotateActive = false;
                let newValue = 1;
                const fadeOutLegend = setInterval(function(){ 
                    if (newValue > 0) {
                        newValue -= 0.01;
                    } else if (newValue < 0) {
                        explore_legend.material.opacity = 0;
                        clearInterval(fadeOutLegend);
                    }
                    explore_legend.material.opacity = newValue;
                }, 10);
                clearInterval(autoRotate);
            }
            controls.update();
        }, 500);
    }

    manageZoom(source) {
        window.addEventListener('mousewheel', (event)=>{
            const siteOverlay = document.querySelector('#site-overlay');
            if(siteOverlay.classList.contains('overlay--body')){
                return;
            }
            if(source == undefined || source == null) return;
            var raycaster = new THREE.Raycaster();
            var mouse = new THREE.Vector2();
            mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
            mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1; 
            raycaster.setFromCamera(mouse, camera );
            var intersects = raycaster.intersectObjects([source], true);

            if(intersects.length >= 1){
                event.preventDefault();
                fovTmp = camera.fov + (event.deltaY * 0.05);
                if (fovTmp <= fovMin) {
                    camera.fov = fovMin;
                }else if (fovTmp >= fovMax) {
                    camera.fov = fovMax;
                }else{
                    camera.fov = fovTmp;
                }
                camera.updateProjectionMatrix();
            }
        }, {passive: false});
    } 

    manageLights() {
        camera.position.set(0, 0, -150);
        let pointLight = new THREE.PointLight(16777215, 0.3);
        pointLight.position.set(0, 5, 0);
        scene.add(pointLight);
    
        let light = new THREE.DirectionalLight(16777215, 2);
        light.position.set(0, 1, 0.3);
        scene.add(light);
    
        let light2 = light.clone();
        light2.position.x = 1;
        light2.position.y = -0.5;
        light2.position.z *= -1;
        scene.add(light2);    
    }

    async manageHotSpots(){
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);

        for( let { coordinates, path, width, height, id } of annotionDetails ){

            // Point
            const pointMaterial = new THREE.SpriteMaterial({
                depthTest: false,
                sizeAttenuation: false
            });

            pointMaterial.onBeforeCompile = ( shader )=>{

                Object.assign(shader.uniforms, {
                    time: { value: 0 },
                    duration: { value: 2 },
                    visibility: { value: 0 }
                });

                shader.defines = {
                    USE_UV: true
                };

                shader.fragmentShader = `
					uniform float time;
					uniform float duration;
					uniform float visibility;

					varying vec2 vUv;

					float circle(in vec2 vUv, in float radius, in float smoothness){

						vec2 dist = vUv - vec2(0.5);

						return 1.0 - smoothstep(radius - (radius * smoothness), radius+(radius * smoothness), dot(dist, dist) * 4.0);

					}


					void main(){
						float progress = mod(time, duration) / duration;
						float innerCircle = circle(vUv, 0.25, 0.08);
						float outerCircle = (circle(vUv, mix(0.25, 0.5, progress), 0.1) - circle(vUv, mix(0.1, 0.5, progress), 0.1));
						gl_FragColor.rgba = vec4(1.0, 1.0, 1.0, (innerCircle + outerCircle) * visibility);
					}
				`;

                pointMaterial.userData = { shader };

            };

            const point = new THREE.Sprite(pointMaterial);
            point.scale.set(0.015, 0.015, 1);
            point.position.set(...coordinates);
            point.material.opacity = 0;
            point.name= id;
            scene.add(point);
            clickablePoints.push(point);

            const spriteMaterial = new THREE.SpriteMaterial({
				color: 0xFFFFFF,
				map: new THREE.TextureLoader().load(path),
				depthTest: false,
				opacity: 0
			});
			spriteMaterial.toneMapped = false;

            const textRatio = (width / height);
			const textScale = 0.16;
			const textWidth = textScale * textRatio;
			const textHeight = -textScale;

            const legend = new THREE.Sprite(spriteMaterial);
			legend.scale.set(textWidth, textHeight, 1);
			legend.center.set(0.2, 0.5);
			legend.position.set(...coordinates).add(new THREE.Vector3(0, 0.08, 0));
            legend.name = id;
            scene.add(legend);
            clickablePoints.push(legend);

            annotions.push({ point, legend, visible: false });
        }

        document.addEventListener('click', this.clickOnSprite, { passive: false});
        document.addEventListener('touchend', this.clickOnSprite, { passive: false});
        document.addEventListener('mousemove', this.hoverOnSprite, { passive: false});
    }

    async exploreText(){
        const exploreTextPath = 'https://cdn.shopify.com/s/files/1/0575/2317/5576/files/Rotate_Bottle_to_Explore_the_Fragrance_2.png';

        const spriteMaterial = new THREE.SpriteMaterial({
            color: 0xFFFFFF,
            map: new THREE.TextureLoader().load(exploreTextPath),
            depthTest: false
        });
        spriteMaterial.toneMapped = false;

        const textRatio = (300 / 30);
        const textScale = 0.09;
        const textWidth = textScale * textRatio;
        const textHeight = -textScale;

        explore_legend = new THREE.Sprite(spriteMaterial);
        explore_legend.scale.set(textWidth, textHeight, 1);
        explore_legend.center.set(0.2, 0.5);
        explore_legend.position.set(-0.25, -0.24, 0).add(new THREE.Vector3(0, 0.08, 0));
        explore_legend.name = 'explore-text';
        scene.add(explore_legend);
    }

    clickOnSprite(event){
        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
        if(event.type == 'click'){
            mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
            mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1; 
        }
        else{
            mouse.x = (event.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
            mouse.y = - (event.changedTouches[0].clientY / window.innerHeight) * 2 + 1;
        }

        raycaster.setFromCamera( mouse, camera );
    
        var intersects = raycaster.intersectObjects(clickablePoints, true);
        intersects.forEach(function(element){
            const objectName = element.object.name;
            const pointOpacity = element.object.material.opacity;
            if(pointOpacity <= 0) return;
            switch(objectName) {
                case 'the-campain':
                  window.location.href = '/pages/campaign';
                  Utility.vibrateDevice();
                  break;
                case 'the-bottle':
                    window.location.href = '/pages/bottle';
                    Utility.vibrateDevice();
                  break;
                case 'behind-the-scene':
                    window.location.href = '/pages/behind-scenes';
                    Utility.vibrateDevice();
                  break;
                case 'the-fragrance':
                    window.location.href = '/pages/fragrance';
                    Utility.vibrateDevice();
                  break;
                default:
                  // code block
              }
        });
    }

    hoverOnSprite(event){
        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
        mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
        mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1; 
        raycaster.setFromCamera( mouse, camera );

        var intersects = raycaster.intersectObjects(clickablePoints, true);
        if(intersects.length > 0) {
            const pointOpacity = intersects[0].object.material.opacity;
            if(pointOpacity > 0) document.body.style.cursor = 'pointer';
        } else {
            document.body.style.cursor = 'default';
        }
    }

    manageBGandEnvfiles(){
        // Set Background Image
        new RGBELoader().setDataType(THREE.UnsignedByteType)
            .load('https://cdn.shopify.com/s/files/1/0575/2317/5576/files/Final_Background.hdr', (texture) => {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;
            pmremGenerator.compileCubemapShader();
            scene.background = envMap;
            });
        // Set Envirement Image
        new RGBELoader().load('https://cdn.shopify.com/s/files/1/0575/2317/5576/files/Final_envirement.hdr', (texture) => {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;
            pmremGenerator.compileCubemapShader();
            scene.environment = envMap;
        });
    }

    frameArea(sizeToFitOnScreen, boxCenter, camera) {
        const halfSizeToFitOnScreen = sizeToFitOnScreen;
        const halfFovY = THREE.MathUtils.degToRad(camera.fov * 45);
        const distance = halfSizeToFitOnScreen / Math.tan(halfFovY * 45);
        // compute a unit vector that points in the direction the camera is now
        // in the xz plane from the center of the box
        const direction = (new THREE.Vector3())
            .subVectors(camera.position, boxCenter)
            .multiply(new THREE.Vector3(1, 0, 1))
            .normalize();

        // move the camera to a position distance units way from the center
        // in whatever direction the camera was from the center already
        camera.position.copy(direction.multiplyScalar(distance).add(boxCenter));
        camera.updateProjectionMatrix();

        // point the camera to look at the center of the box
        camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);
    }

    resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if(window.innerWidth <= 768) height = height - 45;

        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
            renderer.setSize(width, height, true);
        }
        return needResize;
    }

    updateRenderer() {
        const sourceModal = scene.getObjectByName("BILLIE_Plane001");
        this.rendererPropUpdate();
        this.manageZoom(sourceModal);
        this.manageHotSpots();
        setTimeout(() => {
            this.manageAutoRotate();
        }, 1000);

        // Adjust reflection opacity based on camera polar angle
        controls.addEventListener('change', (event)=>{
            if(autoRotateActive == true) return;

            var pointsByDistance = annotions.map(function (_ref4, index) {
                var point = _ref4.point;
                var distance = point.position.distanceTo(camera.position);
                return {
                    index: index,
                    distance: distance,
                };
            })
            .sort(function (previous, current) {
                return previous.distance - current.distance;
            });

            for (var point = 0, length = annotions.length; point < length; point++) {
                annotions[point].visible = pointsByDistance[0].index === point;
                annotions[point].point.material.opacity = (pointsByDistance[0].index === point) ? 1 : 0;
                annotions[point].legend.material.opacity = (pointsByDistance[0].index === point) ? 1 : 0;
            }

            for( let { point, legend, visible } of annotions ){
                if( point.material.userData.shader ){
                // Update for animation
                point.material.userData.shader.uniforms.time.value = 1;
                point.material.userData.shader.uniforms.visibility.value = Math.max(0, Math.min(1, (point.material.userData.shader.uniforms.visibility.value + (visible ? 0.1 : -0.1))));
                }
            }
        });
    }

    render() {
        if (this.resizeRendererToDisplaySize(renderer)) {
            const canvas = renderer.domElement;
            camera.aspect = canvas.clientWidth / canvas.clientHeight;
            if(document.documentElement.clientWidth <= 768) camera.fov = 25;
            camera.updateProjectionMatrix();
        }
        renderer.render(scene, camera);
        if(autoRotateActive == true) controls.update();
    }

    loadGLBModal() {
        // Load GLB file with details
        const gltfLoader = new GLTFLoader();
        gltfLoader.load('https://cdn.shopify.com/s/files/1/0575/2317/5576/files/Final_3D_Model_Desktop.glb', (gltf) => {
            const root = gltf.scene;
            scene.add(root);
            gltf.scene.traverse(function (element) {
                if(element.isMesh) {
                    element.material.normalMap.anisotropy = 0;
                    element.material.normalMap.minFilter = THREE.LinearFilter;
                    element.material.normalMap.magFilter = THREE.LinearFilter;
                    element.material.normalScale.multiplyScalar(0.35);
                    element.material.normalMap.needsUpdate = true;
                    // element.material.shading = THREE.SmoothShading;
                    element.flatShading = false;
                    // element.geometry.computeVertexNormals();
                }
            });

            // compute the box that contains all the stuff
            const box = new THREE.Box3().setFromObject(root);
            const boxSize = box.getSize(new THREE.Vector3()).length();
            const boxCenter = box.getCenter(new THREE.Vector3());
            this.frameArea(boxSize, boxCenter, camera);

            // update the Trackball controls to handle the new size
            controls.maxDistance = 5;
            controls.target.copy(boxCenter);
            controls.update();

            this.exploreText();
            this.updateRenderer();
            animate(0);
        });
    }
}

// functions needed to add annimation to Hotspots
function animate(now) {
    setTimeout( function() {
        var _iterator2 = _createForOfIteratorHelper(annotions),_step2;
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _step2.value,
                point = _step2$value.point,
                visible = _step2$value.visible;

            if (point.material.userData.shader) {
                point.material.userData.shader.uniforms.time.value = now / 1000; // Fade in if closest point or fade out
                point.material.userData.shader.uniforms.visibility.value = Math.max(0, Math.min(1, point.material.userData.shader.uniforms.visibility.value + (visible ? 0.1 : -0.1)));
            }
        }
        requestAnimationFrame(animate);
        bottleModal.prototype.render();
    }, 1000/60);
}

typeof bottleModal !== 'undefined' && new bottleModal();
